import { STATE } from "./names";

export default () => {
    return {
    };
};